import {IonAvatar, IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel, IonList, IonMenuButton, IonNote, IonPage, IonRouterLink, IonRow, IonText, IonThumbnail, IonTitle, IonToolbar, useIonRouter, useIonToast} from '@ionic/react';
import {capitalize, productInfo} from '../utils';
import {useStoreState} from 'pullstate';

import {Pg_A_1_Store, push_pg_A_1__Login, push_pg_A_1__Logout} from "../store/Pg_A_Store";
import {getPageData, getQuotes} from "../store/Selectors";
import React, {useEffect, useState} from "react";
import {QuoteItem} from "../components/QuoteItem";
import {ContractItem} from "../components/ContractItem";
import {fetch_pg_1_2} from "../store/Pg_1_Store";
import {useAppUtil, useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import CustomPage from "./CustomPage";
import {PageHeader} from "./PageHeader";
import {Modal} from "./Modal";
import {tab1SideMenu} from "../components/sideMenu/PageSideMenus";
import {personCircle} from "ionicons/icons";
import CustomField from "../components/CustomField";
import {useParams} from "react-router";
import {useFormInput, validateForm} from "../_/useForms";
import {Action} from "../components/Action";
import {IconWave} from "../components/IconWave";

import styles_A_0 from './Pg_A_0.module.scss';
import styles_Common from './Common.module.scss';
import indexBy from 'underscore/modules/indexBy.js';
import {ActionLink} from "../components/ActionLink";
import {navToPg_1_1, navToPg_1_25, navToPg_8_1, navToPg_B_1, navToPg_C_1} from "./Utils";
import queryString from "query-string";
import classNames from 'classnames';
import logo from '../srcicons/logo.svg';
import styles from "./Common.module.scss";
export const useLoginFields = () => {
    return [
        {
            id: "email",
            label: "電子郵件",
            required: true,
            input: {

                props: {
                    type: "email",
                    placeholder: "電子郵件",
                    autocomplete: "username",
                },
                state: useFormInput("")
            }
        },
        {
            id: "password",
            label: "密碼",
            required: true,
            input: {

                props: {
                    type: "password",
                    placeholder: "密碼",
                    autocomplete: "password"
                },
                state: useFormInput("")
            }
        }
    ];
}

const Pg_A_1 = (props) => {
    const pageId = "pg_a_1";
    const pageName = "pg_a_1";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    const router = useIonRouter();

    let {redirTo = null}: {
        redirTo: string | null,
    } = queryString.parse(window.location.search) as any;

    useEffect(() => {
        setSideMenu({options: sideMenuOptions, side: "start", pageName: pageId});
    }, []);

    useEffect(() => {
        //fetch_Pg_A_1();
    }, []);

    useEffect(() => {
        if (props.location.pathname === "/tabs/1_1") {
            setSideMenu({options: sideMenuOptions, side: "start", pageName: pageName});
        }
    }, [props.location]);

    //const pgData = useStoreState(Pg_A_1_Store, getPageData);

    //const saved = useStoreState(QuoteStore, getSavedQuotes);
    const [amountLoaded, setAmountLoaded] = useState(20);

    const fetchMore = async e => {
        setAmountLoaded(amountLoaded => amountLoaded + 20);
        e.target.complete();
    }


    //#region push login
    const params = useParams();

    const fields = useLoginFields();
    const [errors, setErrors] = useState(false);


    const appUtil = useAppUtil();

    const push_login = async () => {
        const errors = validateForm(fields);
        setErrors(errors);

        if (!errors.length) {
            //  Submit your form here
            let keyedFields = indexBy(fields, 'id');
            const username = fields && (keyedFields.email as any).input.state.value;
            const password = fields && (keyedFields.password as any).input.state.value;
            await appUtil.toast.present('登入中...', 10000)
            if (await push_pg_A_1__Login({
                p1: username,
                p2: password,
            })) {
                await appUtil.toast.dismiss();
                await appUtil.toast.present('登入成功', 1000)

                if (redirTo != null) {
                    window.location.replace(redirTo);
                } else {
                    navToPg_8_1(router);
                }
            } else {
                await appUtil.toast.dismiss();
                await appUtil.toast.present('登入失敗', 1000)
            }
        }
    }
    //#endregion

    const click_forgetPassword = async () => {
        navToPg_B_1(router);
    }

    const click_registerNewAccount = async () => {
        navToPg_C_1(router);
    }

    //#endregion

    // useEffect(() => {
    //
    //     return () => {
    //
    //         fields.forEach(field => field.input.state.reset(""));
    //         setErrors(false);
    //     }
    // }, [params]);

    //const List_合約 = pgData?.Root?.List_合約 ?? [];
    //const categories = Object.keys(productInfo);

    return (
        <IonPage id={pageId}>
            <CustomPage name={pageId} showLargeHeader={false} sideMenu={false} backButton={true}>
                {/*<PageHeader count={sideMenuOptions.length} pageName={pageName}/>*/}

                <IonGrid className="ion-padding">
                    <IonRow>
                        <IonCol size="12" className={styles_A_0.headingText}>
                            <IonCardTitle color="primary">廠商行動平台</IonCardTitle>
                            <h4>登入頁</h4>
                        </IonCol>
                    </IonRow>


                    <IonCard className={styles_A_0.cardbg}>
                        {/*<IonCardHeader>*/}
                        {/*    <IonCardTitle>Card Title</IonCardTitle>*/}
                        {/*    <IonCardSubtitle>Card Subtitle</IonCardSubtitle>*/}
                        {/*</IonCardHeader>*/}
                        <IonCardContent>
                            {/*<IonList>*/}
                            {/*    <IonItem>*/}
                            {/*        <IonThumbnail slot="start">*/}
                            {/*            <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />*/}
                            {/*        </IonThumbnail>*/}
                            {/*        <IonLabel>Item</IonLabel>*/}
                            {/*    </IonItem>*/}
                            {/*</IonList>*/}
                            <IonCol size="12">
                                {fields.map(field => {
                                    return <React.Fragment>
                                        {field.label}:
                                        <CustomField inputClassName={styles_A_0.field} key={field.id} field={field} errors={errors}/>
                                    </React.Fragment>
                                })}

                                <IonButton className="custom-button" expand="block" onClick={push_login}>登入</IonButton>

                                {/*<div className="ion-text-center ion-margin-top ion-padding-top">*/}
                                {/*    <ActionLink link={`/B_1`}><IonText>忘記密碼</IonText></ActionLink> | <ActionLink link={`/C_1`}><IonText>註冊帳號</IonText></ActionLink>*/}
                                {/*</div>*/}
                            </IonCol>
                        </IonCardContent>
                    </IonCard>
                </IonGrid>

                {/*{(showModal && modalOptions) &&*/}
                {/*    <Modal showModal={showModal} modalOptions={modalOptions} close={() => setShowModal(false)}/>*/}
                {/*}*/}


                {/*<IonGrid className={classNames("ion-padding", styles_Common.footer)}>*/}
                {/*    <div className={styles_Common.footerInnerContainer}>*/}
                {/*    <IonRow>*/}
                {/*        <IonCol size="12">*/}
                {/*            <IonIcon className={classNames(styles_Common.footerIcon, "fl")} src={logo}></IonIcon>*/}
                {/*            <IonIcon className={classNames(styles_Common.footerIcon, "fr")} src="/assets/icon/logo-youtube.svg"></IonIcon>*/}
                {/*        </IonCol>*/}
                {/*    </IonRow>*/}

                {/*    <IonRow>*/}
                {/*        <IonCol size="12" className={styles_Common.footerTextContainer}>*/}
                {/*            <div className={classNames("fl", styles_Common.footerText )}>*/}
                {/*            <div>EMJ</div>*/}
                {/*            <div>PetJourney.ai</div>*/}
                {/*            <div>SDGs Passport</div>*/}
                {/*            <div>xxxxxxxxx</div>*/}
                {/*            </div>*/}
                {/*        </IonCol>*/}
                {/*    </IonRow>*/}
                {/*    </div>*/}
                {/*</IonGrid>*/}
            </CustomPage>



            {/*<IonFooter>*/}
            {/*    <IonGrid className="ion-no-margin ion-no-padding">*/}
            {/*        <Action message="Don't have an account?" text="Sign up" link="/C_1"/>*/}
            {/*        <IconWave/>*/}
            {/*    </IonGrid>*/}
            {/*</IonFooter>*/}

            {/*<IonFooter className={classNames("ion-padding-bottom ion-padding-start ion-padding-end", styles_Common.footer)} style={{paddingBottom: "3rem"}} >*/}
            {/*    <IonRow className="ion-justify-content-between">*/}
            {/*        <IonCol size="8">*/}
            {/*            <h1>Total</h1>*/}
            {/*        </IonCol>*/}

            {/*        <IonCol size="4">*/}
            {/*            <h1>2222</h1>*/}
            {/*        </IonCol>*/}
            {/*    </IonRow>*/}
            {/*    <IonButton expand="block" color="dark">Checkout &rarr;</IonButton>*/}
            {/*</IonFooter>*/}
        </IonPage>
    );
};

export default Pg_A_1;
